import React from 'react';
import { Container, Grid, Typography } from '@mui/material';
import { styled, keyframes } from '@mui/system';
import image from '../../images/servicedetalis 1.webp';

// Floating animation for the image
const floatAnimation = keyframes`
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-20px);
  }
  100% {
    transform: translateY(0);
  }
`;

const Image = styled('img')(({ theme }) => ({
  borderRadius: '20px',
  boxShadow: '0 6px 15px rgba(0, 0, 0, 0.1)',
  animation: `${floatAnimation} 3s ease-in-out infinite`,
  width: '100%',
  transition: 'transform 0.3s ease',
  '&:hover': {
    transform: 'scale(1.05)',
  },
  [theme.breakpoints.up('md')]: {
    width: '450px',
  },
}));

const GradientText = styled(Typography)({
  background: 'linear-gradient(90deg, rgba(255,0,150,1) 0%, rgba(0,204,255,1) 100%)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
});

const Services = () => {
  return (
    <Grid sx={{ marginTop: { md: '60px' } }}>
      <Container sx={{ py: 5 }}>
        <Grid container alignItems="center">
          <Grid item xs={12} md={5}>
            <Image src={image} alt="Web Design and Development" />
          </Grid>
          <Grid item xs={12} md={7}>
            <GradientText variant="overline" sx={{ fontWeight: 'bold', mb: 2, fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif" }}>
              OVERVIEW
            </GradientText>
            <Typography variant="h2" fontSize="40px" sx={{ fontWeight: 600, color: '#0a003d', mb: 2, fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif" }}>
              Web Design and Development Service
            </Typography>
            <Typography variant="subtitle1" sx={{ color: '#6c6c6c', mb: 3, fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", lineHeight: 1.6 }}>
              We offer exceptional web development services to improve your online presence and boost your business. Our team of experts is dedicated to creating seamless web solutions that captivate your audience and deliver tangible results. Let us help your brand thrive in the digital world. Contact us now to begin your online business!
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Grid>
  );
};

export default Services;
